import { Tweens } from "phaser";
import GameConfig from "../core/data/GameConfig";
import { GameObject } from "../core/GameObject";
import PlayerData from "../PlayerData";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { FlyState } from "./FlyState";
import { GameState } from "./GameState";
import { LTGame } from "./LTGame";
import { Slingshot } from "./Slingshot";

export class LaunchState extends GameState {
	startingTweens: Tweens.Tween[]=[];
	tutImages: Phaser.GameObjects.Image[] = [];
	tutTimer: Phaser.Time.TimerEvent;
	
	start(): void {
		const slingshot = this.game.slingshot;
		slingshot.once(Slingshot.ON_RELEASE, this.onShoot, this);
		const saveData = PlayerData.Instance.saveData;
		saveData.firstTimeUser = false;
		PlayerData.Instance.save();
		this.game.playIntroTweens();
		this.scene.ui.launchMeter.pause(false);
		
		if (!saveData.launchedSlingshot) {
			this.slingshotTutorial();
		}
		else {
			this.tutTimer = this.scene.time.delayedCall(3000, () => this.slingshotTutorial());
		}
	}

	slingshotTutorial() {
		const dots = new GameObject(this.scene);
		let dottedLine = dots.addImage("tutDots");
		dottedLine.setOrigin(1, 0);
		dots.alpha = 0;

		const hand = new GameObject(this.scene);
		let img = hand.addImage("tutHand");
		img.setOrigin(10 / img.width, 100 / img.height);
		hand.angle = 45;
		this.scene.addObject(dots, "foreground");
		this.scene.addObject(hand, "foreground");
		dots.addComponent(new DestroyOffscreen(dots, true, true, 800));
		hand.addComponent(new DestroyOffscreen(hand, true, true, 800));
		dots.setPosition(this.game.slingshot.x - 20, this.game.slingshot.y + 10);
		hand.setPosition(this.game.slingshot.x, this.game.slingshot.y);

		const t1 = this.scene.tweens.add({
			targets: hand,
			x: { from: hand.x, to: hand.x - 140 },
			y: { from: hand.y, to: hand.y + 130 },
			ease: Phaser.Math.Easing.Quadratic.InOut,
			duration: 1000,
			repeat: -1,
			delay: 500,
			hold: 500,
			repeatDelay: 700,
		});

		const fadeDuration = 500;
		const handAdjustY = 25;
		const t2 = this.scene.tweens.add({
			targets: hand,
			alpha: {from: 1, to: 0},
			scale: {from: 1, to: 1.25},
			ease: Phaser.Math.Easing.Quadratic.InOut,
			duration: fadeDuration,
			repeat: -1,
			yoyo: true,
			delay: 1500,
			repeatDelay: 1200,
			onStart: () =>{
				if(this.scene != undefined){
					img.setTexture("tutHandLift");
					hand.angle = -10;
					img.y += handAdjustY;
					setTimeout(() => {
						img.setTexture("tutHand");
						hand.angle = 45;
						hand.scale = 1;
						img.y -= handAdjustY;
					}, fadeDuration);

					this.scene.tweens.add({
						targets: dots,
						alpha: 0,
						duration: fadeDuration,
					});
				}
			},
			onRepeat: () =>{
				if(this.scene != undefined){
					img.setTexture("tutHandLift");
					hand.angle = -10;
					img.y += handAdjustY;
					setTimeout(() => {
						img.setTexture("tutHand");
						hand.angle = 45;
						hand.scale = 1;
						img.y -= handAdjustY;
					}, fadeDuration);

					this.scene.tweens.add({
						targets: dots,
						alpha: 0,
						duration: fadeDuration,
					});
				}

			},
		});
		const t3 = this.scene.tweens.add({
			targets: dots,
			alpha: {from: 0, to: 1},
			ease: Phaser.Math.Easing.Quadratic.InOut,
			repeat: -1,
			duration: 700,
			delay: 500,
			hold: 500,
			repeatDelay: 1000,
		});
		this.startingTweens.push(t1, t2, t3);
		this.tutImages.push(dottedLine, img);
	}

	onShoot(vel: Phaser.Math.Vector2): void {
		for (const tween of this.startingTweens){
			tween.stop();
		}
		const tweenDuration = GameConfig.get("slowTutTweenDuration") as number;
		const player = this.scene.ltGame.player;
		const overlay = this.scene.ltGame.overlayObj;
		if (overlay) {
			this.scene.layers.addObject(overlay, "player");
			this.scene.layers.get("player").bringToTop(player)
		}

		const tween = this.scene.tweens.add({
			targets: this.scene.ltGame.overlayObj,
			alpha: 0,
			duration: tweenDuration,
			onUpdate: () => {
				this.scene.ltGame.overlayObj.setPosition(player.x, player.y);
			}
		});

		this.tutTimer?.remove();
		this.scene.soundManager.play("slingshotRelease");
		if (this.scene.ui.launchMeter.isPerfect()) {
			this.scene.soundManager.play("perfectLaunch");
			this.scene.ui.launchMeter.playPerfAnim();
		} else this.scene.ui.launchMeter.hideGlow();
		for (const img of this.tutImages) img.setVisible(false);

		this.scene.missionTracker.updateMissionProgress("launchTimes", 1);
		this.scene.missionTracker.setMissionProgress("reachEnvironmentIndex", 0);

		this.game.player.planckBody.setDynamic();
		this.game.player.planckBody.setLinearVelocity(vel.x, vel.y);
		this.game.player.evalFlight();
		this.game.slingshot.shootAnim();
		PlayerData.Instance.saveData.launchedSlingshot = true;
		this.game.switchState(new FlyState(this.game, this.scene));

	}

}